export default "__VITE_ASSET__DF7Hd1Sa__"